
function activateEditTab(side) {
  // If bag overlays exist in DOM, EDIT TOP/POCKET is handled by bag_upload_customizer.js
  if ($('.front_image .b2b_overlay--pocket').length > 0) return;
  var isFront = (side === 'front');
  var activeTab   = isFront ? '.front_tab'  : '.back_tab';
  var inactiveTab = isFront ? '.back_tab'   : '.front_tab';
  var otherImage  = isFront ? '.back_image' : '.front_image';
  var ownImage    = isFront ? '.front_image': '.back_image';
  var ownCheckbox   = isFront ? '#inverseCheckbox'    : '#backinverseCheckbox';
  var otherCheckbox = isFront ? '#backinverseCheckbox': '#inverseCheckbox';
  var ownS   = isFront ? '.s1' : '.s2';
  var otherS = isFront ? '.s2' : '.s1';

  $(activeTab).addClass('active');
  $(inactiveTab).removeClass('hide');
  $(activeTab).removeClass('hide');
  $(inactiveTab).removeClass('active');
  $('.edit_front_tab').addClass('hide');
  $('.edit_back_tab').addClass('hide');
  setTimeout(function() {
    $(activeTab).addClass('active');
  }, 1000);

  /* if text upload section active */
  if ($(".inner_text_design_content.active")[0]) {
    $('.inner_text_design_content').removeClass('active');
    $('.front_text_preview').removeClass('active').addClass('hide');
    $('.back_text_preview').removeClass('active').addClass('hide');
    $('.left_image_customize').removeClass('both_active');
    $(otherImage).removeClass('active');
    $(".color_customize_variants").css('display', 'block');
    $('.color_customize_variants').removeAttr('style');
    $('.addtocart_box').addClass('hide');
    $('.upload_nav_design .clear_btn').removeClass('hide');
    $('.upload_nav_design .preview_btn').removeClass('hide');
    $('.customize-selection').removeClass('hide');
  }

  /* logo box */
  if ($(".inner_logo_designs_content.active")[0]) {
    $(".color_customize_variants").css('display', 'block');
    $('.left_image_customize').removeClass('both_active');
    $(otherImage).removeClass('active');
    $('.gallery_nav_design .clear_btn').removeClass('hide');
    $('.gallery_nav_design .preview_btn').removeClass('hide');
    $('.gallery_nav_design .addtocart_box').addClass('hide');
    $('.addtocart_box').addClass('hide');
    $('.inner_logo_designs_content').removeClass('active');
    $('.animal, .family, .sports, .line, .travel, .nature, .weekend').addClass('hide');
    $('.back_logo.back_btn').removeClass('hide');
    $('.back_animal.back_inner, .back_family.back_inner, .back_sports.back_inner').addClass('hide');
    $('.back_lineart.back_inner, .back_nature.back_inner, .back_weekend.back_inner').addClass('hide');
    $('.back_nature_travel.back_inner').addClass('hide');
    $('.back_dog, .back_cats, .dogs, .cats').addClass('hide');
    $(".inner_gallerry_wraper.pets_gallery").removeClass("hide");
  }

  /* fathers days outer */
  if ($(".outerinner_logo_designs_content.active")[0]) {
    $('.left_image_customize').removeClass('both_active');
    $(otherImage).removeClass('active');
    $('.outergallery_nav_design .clear_btn').removeClass('hide');
    $('.outergallery_nav_design .preview_btn').removeClass('hide');
    $('.outergallery_nav_design .addtocart_box').addClass('hide');
    $('.back_outer.back_btn').removeClass('hide');
    $('.outerinner_logo_designs_content').removeClass('active');
  }

  if ($(".selected_design_box.active")[0]) {
    $(".selected_design_box.active .inner_selected_design").css('display', 'block');
    $(".color_customize_variants").css('display', 'block');
    $(otherImage).removeClass('active');
    $('.left_image_customize').removeClass('both_active');
    $('.addtocart_box').addClass('hide');
    $(ownCheckbox).css('display', 'inline');
    $(ownS).css('display', 'inline');
    $(otherCheckbox).css('display', 'none');
    $(otherS).css('display', 'none');
  }

  $('.customize-selection').removeClass('hide');
  $('.selected_design_box').removeClass('active');
  $('.inner_selected_design.design_uplod.customization-section').removeClass('active').removeAttr('style');

  var html = $(ownImage + ' .cstm_textup').html();
  if (html != '' && html != ' ') {
    $(ownImage + ' .text_uploaded').removeClass('hide').addClass('active');
  }
}

$(document).on('click', '.edit_front_tab', function(e) {
  e.preventDefault();
  activateEditTab('front');
});

$(document).on('click', '.edit_back_tab', function(e) {
  e.preventDefault();
  activateEditTab('back');
});
